import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router'
import { LoginService } from '../modules/login/service/login.service'
import { catchError, map, of } from 'rxjs'

const TOKEN_KEY = '@otimus_clinic:jwt_token'

export const unlinkGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const loginService = inject(LoginService)
  const router = inject(Router)

  const provider = route.queryParams['provider'] as string | undefined
  const token = localStorage.getItem(TOKEN_KEY)

  // Extract other query params to preserve (excluding provider)
  const otherParams = Object.fromEntries(
    Object.entries(route.queryParams).filter(([key]) => key !== 'provider')
  )

  if (!token) {
    router.navigate(['/login'], {
      queryParams: { ...otherParams, error: 'Not authenticated' },
    })
    return of(false)
  }

  const successMessage = provider
    ? `${provider} account unlinked successfully`
    : 'All OAuth accounts unlinked successfully'

  const errorMessageDefault = provider
    ? `Failed to unlink ${provider} account`
    : 'Failed to unlink OAuth accounts'

  return loginService.unlinkOAuthProvider(token, provider).pipe(
    map(() => {
      router.navigate(['/login'], {
        queryParams: { ...otherParams, message: successMessage },
      })
      return false
    }),
    catchError((error) => {
      const errorMessage = error?.error?.message || errorMessageDefault
      router.navigate(['/login'], {
        queryParams: { ...otherParams, error: errorMessage },
      })
      return of(false)
    })
  )
}
